import { OidcAccessToken, OidcClient, OidcTokenStorage } from '@ori/auth';

export interface TokenConfiguration {
  readonly tenant: string;
  readonly identityUrl?: string;
  readonly forceReload?: boolean;
}

export const getToken = async ({ tenant, identityUrl, forceReload }: TokenConfiguration) => {
  if (window.ori?.tokenService) {
    const oriToken = await window.ori.tokenService.getToken();

    if (oriToken) {
      return new OidcAccessToken(oriToken.Token);
    }
  }

  // only on dev machine, not needed elsewhere
  if (__DEV__) {
    const oidcTokenStorage = new OidcTokenStorage();
    let token;

    try {
      token = oidcTokenStorage.getAccessToken();
    } catch {
      throw new Error('Can not obtain token');
    }

    if (token && !forceReload) {
      return token;
    }
    if (identityUrl) {
      const clientId = 'ImplicitTest-V2';

      const oidcClient = new OidcClient(
        {
          callbackUrl: '#',
          redirectUrl: window.location.href,
        },
        {
          clientId,
          identityUrl,

          acrValues: `tenant:${tenant}`,
          scope: 'openid profile user_identification',
        },
      );

      oidcClient.doLogin();
    }
  }

  throw new Error('Unsupported token configuration');
};
